import { Box } from "@chakra-ui/react";
import { BESZLA_PUB_META } from "@coimbra-its/api.konyvelo";
import { formatMoney1, TableMeta, useWSysLayoutContext, useWSysMainTable, useWSysPage, useWSysPath, WSysPage, WSysSearch, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useKonyveloApi } from "../store/konyvelo.api";
import { Beszla } from "./Beszla";
import { WSysTableSettings } from "../temp/TableSettings";

const CELLS = new TableMeta(BESZLA_PUB_META)
	.Delete('ID').Delete('DOKID')
	.Delete('HIVSZ').Delete('NETTO').Delete('AFA').Delete('BRUTTO').Delete('DEV').Delete('FIZMOD').Delete('OSZAMLA_IMPORT').Delete('DEV_NETTO').Delete('DEV_AFA')
	.Map2('DEV_BRUTTO', row => formatMoney1(row.DEV_BRUTTO, row.DEV)).Set('DEV_BRUTTO', {width: '200px'})
	.Set('P_KOD', {charWidth:10, width:'100px'})
	.Set('P_NEV', {charWidth:40, width:'350px'})
	.forTable();



export function BeszlaLista() {


	const path = useWSysPath();
	const [q] = path.useParam('q');
	
	// ---------------------
	const tableProps = useWSysMainTable(path, [q]);


	// ---------------------

	const api = useKonyveloApi();
	const [szamlaGetRes, hub] = api.beszlaGet.useData({ q, ...tableProps.forPath });
	const szamlak = szamlaGetRes?.szamlak?.items || [];
	const szamlaPath = path.useChildRow('', szamlak, szamla => szamla.ID);

	const layout = useWSysLayoutContext();
	const page = useWSysPage({ title: 'Bejövő számlák', maxCols: szamlaPath.isOpen ? (Math.max(layout.widthCols - 4, 2)) : 10 });
	

	return <WSysPage page={page} hubs={[hub]}

		tools={<Box display='flex' gap={2}>
			<WSysSearch name='q' />
			<WSysTableSettings orderBy={tableProps.forTable.orderBy} orderByChanged={tableProps.forTable.orderByChanged} cells={CELLS} reset={{orderBy:'', title:'Alaphelyzet (ID desc)'}} />
		</Box>}

	>
		<WSysVert mode="rest">
			<WSysTable
				cells={CELLS}
				rows={szamlak}
				tableInfo={szamlaGetRes?.szamlak.info}
				{...szamlaPath.forTable}
				{...tableProps.forTable}
				mode={3}
				noHead={layout.isMobileFull || true}

			/>
		</WSysVert>

		{/*szamlaPath.on(szamlaPath.forTable.selectedRow && <Beszla DOKID={szamlaPath.forTable.selectedRow.DOKID}  />)*/}
		{szamlaPath.on(szamlaPath.forTable.selectedRow && <Beszla tipus="dokid" oszlaID_or_DokId={szamlaPath.forTable.selectedRow.DOKID}  />)}
	</WSysPage>
}